import { JSX } from "preact"

export function ListHeader(props: { children: JSX.Element }) {
  return <div style={{ minHeight: "56px" }}>{props.children}</div>
}
